import { CanvasSystemIcon } from '@workday/canvas-system-icons-web'

/**
 * Canvas system icons ship as a full <svg> markup string with a fixed `fill` baked into each
 * `<path>` (an invisible "background" path plus one or more visible "fill"/"accent" paths, all
 * the same color). Our Icon renders every path as one `currentColor` shape via the parent
 * svg's `fill`, so by default we pull out just the `d`s and drop the always-invisible background
 * path — that's correct for icons where the background is genuinely meant to stay empty (Trash,
 * Edit, Bell, Home). Some icons (Pin) use the background layer for most of their visible area, so
 * dropping it leaves a hollow gap; pass `includeBackground` to paint it solid instead.
 */
export function canvasIconPaths(icon: CanvasSystemIcon, { includeBackground = false } = {}): string[] {
  /*
  TODO (vic) Nextjs does not have a builtin DOM parser.  We are not going to regex XML we're better than that.
    This means these wrapped canvas icons will not render in SSR without installing jsdom and updating this
    But we do not do SSR so it is not a now problem
  */

  if (typeof window === 'undefined') {
    return []
  }
  const parser = new DOMParser()
  const doc = parser.parseFromString(icon.svg, 'image/svg+xml')
  const paths = doc.querySelectorAll('path')
  return [...paths]
    .filter(path => includeBackground || path.getAttribute('fill') !== 'transparent')
    .map(path => path.getAttribute('d'))
    .filter((d): d is string => Boolean(d))
}
